export default "__VITE_ASSET__fc9104f1__"